import { useState, useEffect } from 'react';
import { useParams, useLocation, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Simulation from './pages/Simulation';
import Application from './pages/Application';
import About from './pages/About';
import Contact from './pages/Contact';
import i18n from './i18n';

type Page = 'home' | 'simulation' | 'application' | 'about' | 'contact';

function App() {
  const { lang } = useParams<{ lang: string }>();
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState<Page>('home');

  // 🔥 Détermine la page active selon l'URL
  useEffect(() => {
    const path = location.pathname;
    
    if (path.includes('/application')) {
      setCurrentPage('application');
    } else if (path.includes('/simulation')) {
      setCurrentPage('simulation');
    } else if (path.includes('/about')) {
      setCurrentPage('about');
    } else if (path.includes('/contact')) {
      setCurrentPage('contact');
    } else {
      setCurrentPage('home');
    }
  }, [location]);

  // 🔥 Change la langue selon l'URL
  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  const handleNavigate = (page: string) => {
    setCurrentPage(page as Page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Layout currentPage={currentPage} onNavigate={handleNavigate}>
      <Routes>
        <Route path="/" element={<Home onNavigate={handleNavigate} />} />
        <Route path="/simulation" element={<Simulation onNavigate={handleNavigate} />} />
        <Route path="/application" element={<Application onNavigate={handleNavigate} />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Layout>
  );
}

export default App;
